import React from "react";
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
} from '@mui/material';
import {
    Typography,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Link,
} from '@mui/material';

import { CustomerTypes } from "../../types";
import dayjs from "dayjs";
import { Label } from "../label";
import { invitationStatusLabel } from "../../sanitalizers/instance-status-label";
import { toast } from "react-toastify";

interface Props {
    visible: boolean,
    customer: CustomerTypes.Model,
    onClose: () => void,
}

export const CustomerInvitesModal: React.FC<Props> = ({ visible, customer, onClose }) => {
    return (
        <Dialog
            scroll={'paper'}
            onClose={onClose}
            open={visible}
            maxWidth="xl"
        >
            <DialogTitle fontWeight={500} mb={1} id="alert-dialog-title">
                {customer?.name} Invites
            </DialogTitle>
            <DialogContent style={{ minWidth: 600 }}>
                <DialogContentText id="alert-dialog-description">
                   List of expired and active invites
                </DialogContentText>

                <TableContainer sx={{ mt: 2 }}>
                    <Table>
                        <TableHead>
                            <TableRow sx={{ height: 10 }}>
                                <TableCell>
                                    <Typography
                                        variant="body2"
                                        fontWeight={500}
                                        sx={{
                                            color: 'text.primary',
                                        }}
                                    >
                                        Email
                                    </Typography>
                                </TableCell>
                                <TableCell>
                                    <Typography
                                        variant="body2"
                                        fontWeight={500}
                                        sx={{
                                            color: 'text.primary',
                                        }}
                                    >
                                        Link
                                    </Typography>
                                </TableCell>
                                <TableCell>
                                    <Typography
                                        variant="body2"
                                        fontWeight={500}
                                        sx={{
                                            color: 'text.primary',
                                        }}
                                    >
                                        Status
                                    </Typography>
                                </TableCell>
                                <TableCell>
                                    <Typography
                                        variant="body2"
                                        fontWeight={500}
                                        sx={{
                                            color: 'text.primary',
                                        }}
                                    >
                                        Opened At
                                    </Typography>
                                </TableCell>
                                <TableCell>
                                    <Typography
                                        variant="body2"
                                        fontWeight={500}
                                        sx={{
                                            color: 'text.primary',
                                        }}
                                    >
                                        Created At
                                    </Typography>
                                </TableCell>
                                <TableCell>
                                    <Typography
                                        variant="body2"
                                        fontWeight={500}
                                        sx={{
                                            color: 'text.primary',
                                        }}
                                    >
                                        Expires At
                                    </Typography>
                                </TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {customer?.invites?.map((invite) => (
                                <TableRow key={invite.id}>
                                    <TableCell>{invite.email || 'N/A'}</TableCell>
                                    <TableCell>
                                        <Link
                                            style={{
                                                cursor: 'pointer',
                                            }}
                                            onClick={() => {
                                                navigator.clipboard.writeText(`${window.location.origin}/onboarding/${invite.id}`);
                                                toast('Link copied to clipboard', { type: 'success' });
                                            }}
                                        >
                                            Click here to copy link
                                        </Link>
                                    </TableCell>
                                    <TableCell>
                                        {
                                            invite.status !== CustomerTypes.OnboardingInvitationStatus.DONE && dayjs(invite?.expiresAt).isBefore(new Date()) ? 
                                            <Label
                                                variant={'ghost'}
                                                color={'error'}
                                            >
                                                Expired
                                            </Label> :
                                            <Label
                                                variant={'ghost'}
                                                color={invitationStatusLabel[invite?.status!]?.color}
                                            >
                                                {invitationStatusLabel[invite?.status!]?.label}
                                            </Label>
                                        }
                                    </TableCell>
                                    <TableCell>
                                        {invite?.openedAt ?
                                            dayjs(invite.openedAt).format('MM/DD/YYYY hh:mm A') : 'N/A'    
                                        }    
                                    </TableCell>
                                    <TableCell>
                                        {invite?.createdAt ?
                                            dayjs(invite.createdAt).format('MM/DD/YYYY hh:mm A') : 'N/A'    
                                        }
                                    </TableCell>

                                    <TableCell>
                                        {invite?.expiresAt ?
                                            dayjs(invite.expiresAt).format('MM/DD/YYYY hh:mm A') : 'N/A'    
                                        }
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </DialogContent>
            <DialogActions style={{ marginTop: -30 }}>
                <Button color='primary' onClick={onClose}>
                    Close
                </Button>
            </DialogActions>
        </Dialog>
    )
}